// removed by extract-text-webpack-plugin
module.exports = {"menu":"src-ui----Menu-module---menu---16w0_","item":"src-ui----Menu-module---item---15UWn","itemActive":"src-ui----Menu-module---itemActive---2Z7WJ"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/Menu.module.scss
// module id = 566
// module chunks = 168707334958949